var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKelvinAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6735 21.9885C11.7263 21.9885 12.347 21.3237 12.347 20.1888V16.7154L13.9429 14.9845L18.7084 21.0485C19.2293 21.7363 19.6948 22 20.3819 22C21.3018 22 22 21.2664 22 20.3264C22 19.8564 21.7783 19.3635 21.2796 18.7215L16.4808 12.6918L20.8917 7.91167C21.3129 7.45314 21.4791 7.07485 21.4791 6.59339C21.4791 5.69926 20.792 5 19.9054 5C19.3512 5 18.9301 5.2178 18.4646 5.74511L12.4467 12.5428H12.347V6.81119C12.347 5.66487 11.7263 5 10.6735 5C9.62063 5 9 5.66487 9 6.81119V20.1888C9 21.3237 9.62063 21.9885 10.6735 21.9885Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5C7 5.88071 5.88071 7 4.5 7C3.11929 7 2 5.88071 2 4.5C2 3.11929 3.11929 2 4.5 2C5.88071 2 7 3.11929 7 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKelvinAlt);
export default __webpack_public_path__ + "static/media/kelvin-alt.739defaccbcb0beb3c50c4230067222c.svg";
export { ForwardRef as ReactComponent };